import React, { Component } from 'react';


export default class RequestAccessSucessLogoutDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: true,
        }
    }
    
	componentDidMount() {
		this.setState({
            showDialog: this.props.showDialog
        });
	}

	logout(event){
		event.preventDefault();
		this.props.logout();
	}
	
	
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="requestAccessSucessLogoutDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{width:'47em'}}>
				<div>
					<h1>Thank You for Registering on GE Appliances CustomerNet!</h1>
					<p>
						Your request has been submitted and is pending approval of the account administrator and/or your GE Area Sales Manager.<br/>
						<br />
						You will be notified via email once approved.
					</p>
				</div>
					<div className="floatRight">
						<a className="blueButton noButton" onClick={this.logout.bind(this)}>Ok</a>
					</div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/App/components/dialogs/requestAccessSuccessLogoutDialog.js